import { Column } from 'react-table';
import { Avatar, Box, styled, Tooltip, Typography } from '@mui/material';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { getFlexWorkerLabel } from 'shared/utils/get-flex-worker-label';
import { DayColumnAccessors } from 'shared/components/calendar/calendar-grid.types';
import { AvailabilityParsed } from '../availability-calendar.types';

export const getGridColDefs = (): Column<AvailabilityParsed<DayColumnAccessors>>[] => {
  const workerColumn: Column<AvailabilityParsed<DayColumnAccessors>> = {
    Header: () => <StyledHeaderCell variant="inherit">Werker</StyledHeaderCell>,
    accessor: 'worker',
    width: '200px',
    Cell: ({ value }: { value: AvailabilityParsed<DayColumnAccessors>['worker'] }) => (
      <StyledContainer>
        <WrapperBox>
          <Avatar src={value.profilePictureUrl} alt="Profile Picture" />
          {value.lenderCompanyName ? (
            <Tooltip
              title={getFlexWorkerLabel({
                employmentType: value.employmentType,
                lenderCompanyName: value.lenderCompanyName,
              })}
            >
              <LabelBox>
                {getFlexWorkerLabel({
                  employmentType: value.employmentType,
                  lenderCompanyName: value.lenderCompanyName,
                })}
              </LabelBox>
            </Tooltip>
          ) : null}
        </WrapperBox>
        <Tooltip title={getFullNameWithInfix(value)}>
          <StyledWorkerCell variant="inherit">{getFullNameWithInfix(value)}</StyledWorkerCell>
        </Tooltip>
      </StyledContainer>
    ),
  };

  return [workerColumn];
};

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(3),
}));

const StyledWorkerCell = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: theme.palette.lwBlack[100],
  padding: theme.spacing(5),
  fontWeight: 'bold',
  textAlign: 'right',
}));
const StyledHeaderCell = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: theme.palette.lwPrimaryAccentDark[40],
  padding: theme.spacing(5),
  fontWeight: 'bold',
  justifyContent: 'center',
  textAlign: 'center',
}));

const LabelBox = styled(Box)(() => ({
  border: '1px solid #eeeeee',
  borderRadius: '16px',
  backgroundColor: 'white',
  padding: '0 8px',
  marginTop: '-8px',
  lineHeight: '12px',
  fontSize: '8px',
  textAlign: 'center',
  zIndex: 100,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
}));

const WrapperBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '30%',
}));
